import FormControlContext from '../context/FormControlContext';
import { createElement, useEffect, useContext, useState } from 'react';
const syncUI = (Component) => {
    return function (props) {
        const [hasInit, setHasInit] = useState(false);
        const { updateForm } = useContext(FormControlContext);
        const { fieldProps, componentProps, decoratorProps, __designMode, children } = props;
        useEffect(() => {
            if (!hasInit) {
                return setHasInit(true);
            }
            if (__designMode !== 'design') {
                return;
            }
            updateForm();
        }, [fieldProps, componentProps, decoratorProps, __designMode, children]);
        return createElement(Component, Object.assign({}, props));
    };
};
export default syncUI;
